import { ALLOWED_INPUT_TYPES, ALLOWED_LABEL_LAYOUTS, sanitizeAllowedString, sanitizeBindable, sanitizeBoolean, sanitizeBoundValue, sanitizeString } from './helpers';
export function sanitizeInput(el) {
  const value = sanitizeBoundValue(el.value);
  if (!value) return null;
  return {
    type: 'Input',
    value,
    label: sanitizeBindable(el.label, sanitizeString),
    labelLayout: sanitizeBindable(el.labelLayout, v => sanitizeAllowedString(v, ALLOWED_LABEL_LAYOUTS)),
    inputType: sanitizeBindable(el.inputType, v => sanitizeAllowedString(v, ALLOWED_INPUT_TYPES)),
    placeholder: sanitizeBindable(el.placeholder, sanitizeString),
    required: sanitizeBindable(el.required, sanitizeBoolean),
    disabled: sanitizeBindable(el.disabled, sanitizeBoolean)
  };
}